import { render, staticRenderFns } from "./DisbursementsTroublesTable.vue?vue&type=template&id=3d1cbbf6"
import script from "./DisbursementsTroublesTable.vue?vue&type=script&lang=js"
export * from "./DisbursementsTroublesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports